import { piniaSettingStoreKey, storageType } from '@/constant/local.key'
import { defineStore } from 'pinia'
import { getPrimaryColors } from '@/utils/color'
import { getDeviceConstants } from '@/hooks/useDevice'
const { DEVICE } = getDeviceConstants()

export const useSettingStore = defineStore('settingStore', {
  state: () => ({
    openSetting: false,
    layoutType: 'defaultLayout',
    pcAsideWidth: 210,
    isDark: false,
    isGrey: false,
    isInvert: false,
    isSideNavHorizontal: false,
    collapse: false,
    showAsideLogo: true,
    showBreadcrumb: true,
    showAside: true,
    showAsidePane: false,
    showFooter: true,
    showTags: true,
    device: '',
    locale: '',
    size: '',
    theme: {
      "r": 46,
      "g": 129,
      "b": 255,
      "a": 1,
      "hex": "#2E81FF"
    },
    pageTransition: 'glow-fade-zoom',
    elementPlusSize: 'default',
  }),
  getters: {
    getCollapse: (state) => state.collapse,
    getPageTransition: (state) => state.pageTransition,
    getThemeMode: (state) => (state.isDark ? 'dark' : 'light'),
    isLTDoubleColumn: (state) => state.layoutType == 'doubleColumn',
    getElementPlusSize: (state) => state.elementPlusSize,
  },
  actions: {
    initSetting() {
      this.toggleTheme(this.isDark)
      this.setGrey(this.isGrey)
      this.setInvert(this.isInvert)
      this.setTheme(this.theme)

      this.setPcAsideWidth(this.pcAsideWidth)
      if (this.device == DEVICE.MOBILE) {
        this.layoutType = 'mobileLayout'
      } else if (this.device != DEVICE.MOBILE && this.layoutType == 'mobileLayout') {
        this.layoutType = 'defaultLayout'
      }
    },
    updateSettings(partial) {
      // 只在设置isGrey或isInvert时做互斥
      if ('isGrey' in partial && partial.isGrey) {
        partial.isInvert = false
      }
      if ('isInvert' in partial && partial.isInvert) {
        partial.isGrey = false
      }
      this.$patch(partial)
      if ('isGrey' in partial || 'isInvert' in partial) {
        this.updateFilter()
      }
    },
    // 更新滤镜效果的函数
    updateFilter() {
      let filterValue = ''
      if (this.isGrey) {
        filterValue += 'grayscale(1) '
      } else {
        filterValue += 'grayscale(0) '
      }
      if (this.isInvert) {
        filterValue += 'invert(80%)'
      } else {
        filterValue += 'invert(0)'
      }
      filterValue = filterValue.trim()
      if (typeof document !== 'undefined') {
        document.body.style.filter = filterValue
      }
    },
    // 设置页面切换动画类型
    setPageTransition(type) { this.pageTransition = type },
    // 设置Element Plus的全局尺寸
    setElementPlusSize(size) {
      console.log('setElementPlusSize', size)
      this.elementPlusSize = size
    },
    setTheme(v) {
      this.theme = v
      getPrimaryColors(this.theme, this.isDark)
    },
    // 切换主题（明暗）
    toggleTheme(isDark = null) {
      if (isDark == null) {
        this.isDark = !this.isDark
      } else {
        this.isDark = isDark
      }
      if (this.isDark) {
        // 设置为暗黑主题
        document.documentElement.classList.add('dark')
      } else {
        // 恢复亮色主题
        document.documentElement.classList.remove('dark')
      }
      this.setTheme(this.theme)
    },
    // 新增互斥切换方法
    setGrey(val) {
      this.isGrey = val
      if (val) this.isInvert = false
      this.updateFilter()
    },
    setInvert(val) {
      this.isInvert = val
      if (val) this.isGrey = false
      this.updateFilter()
    },
    setPcAsideWidth(val) {
      this.pcAsideWidth = val
      document.documentElement.style.setProperty('--web-aside-not-collapse-width', this.pcAsideWidth + 'px')
    },
  },
  persist: {
    key: piniaSettingStoreKey,
    storage: storageType,
    paths: [],
  },
})
